import { matchPath } from 'react-router';
import { compile } from 'path-to-regexp';
import { getRouteContext } from 'router/utils/getRouteContext';

import { DEFAULT_SLUG_REGION } from 'constants/misc';

interface GetUrlByWebUriProps {
  pathname: string;
  language: string;
  region?: string;
  search?: string;
}

export const getUrlByWebUri = ({
  pathname,
  region,
  language,
  search = '',
}: GetUrlByWebUriProps): string => {
  let hasRegionDependency = false;

  let path = '/:language/*';
  let compiledPath = '/:language{/:rest}';

  const routeContext = getRouteContext(pathname);
  if (routeContext.match && routeContext.hasRegionDependency) {
    path = '/:language/:region/*';
    compiledPath = '/:language/:region{/:rest}';
    hasRegionDependency = true;
  }

  const match = matchPath(path, pathname);

  if (match && match.params) {
    const { '*': splat } = match.params as { language?: string; region?: string; '*'?: string };
    const rest = splat || undefined;

    const toPath = compile(compiledPath, {
      encode: false,
    });

    const curRegion = region || (match.params as { region?: string }).region || DEFAULT_SLUG_REGION;
    const newPath = toPath({
      language,
      region: hasRegionDependency ? curRegion : undefined,
      rest,
    });

    return `${newPath}${search}`;
  }

  throw new Error('Invalid pathname: getUrlByWebUri');
};
